import { Component, Input, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-floating-shelf-capacity-modal',
  templateUrl: './floating-shelf-capacity-modal.component.html',
  encapsulation: ViewEncapsulation.None,
  imports: [FormsModule],
})
export class FloatingShelfCapacityModalComponent {
  @Input() productName: string = '';
  @Input() capacity: number = 1;

  constructor(public activeModal: NgbActiveModal) {}

  confirm(): void {
    const value = Math.max(0, Math.floor(Number(this.capacity) || 0));
    this.activeModal.close(value);
  }

  cancel(): void {
    this.activeModal.dismiss();
  }
}
